<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addBankDetail()">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        <div class="search">
          <input
            id="nav_search"
            class="input is-medium"
            placeholder="Search..."
            [formControl]="control"
            [appAutocomplete]="autocomplete"
          />
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(bankDetails | filter: control.value) as result"
              >
                <app-option
                  (click)="clickMe(option.id)"
                  *ngFor="let option of result"
                  [value]="option.BankName"
                >
                  {{ option.BankName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
          <span class="search_icon"
            ><img src="assets/images/top_nav/Magnifiction.svg" alt=""
          /></span>
        </div>
      </div>
    </div>

    <div class="custom_table custom__table">
      <form [formGroup]="bankForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Beneficiary Account Name</span>
          <span class="head">Beneficiary Account Number</span>
          <span class="head">Bank Name</span>
          <span class="head">Sort Code</span>
          <span class="head">BVN</span>
          <span class="head">Branch</span>
          <span class="head">Remark</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="BankDetails">
          <div
            class="td"
            *ngFor="
              let bankDetail of bankForm.get('BankDetails')['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="BeneficiaryAccountName"
                placeholder="Enter Bank Account Name"
            /></span>
            <span
              ><input
                type="text"
                formControlName="BeneficiaryAccountNumber"
                placeholder="Enter Bank Account Number"
            /></span>
            <span
            ><input
              type="text"
              formControlName="BankName"
              placeholder="Enter Bank Name"
          /></span>
          <span
          ><input
            type="text"
            formControlName="SortCode"
            placeholder="Enter Sort Code"
        /></span>

        <span
        ><input
          type="text"
          formControlName="BVN"
          placeholder="Enter BVN Code"
      /></span>
          <span
          ><input
            type="text"
            formControlName="Branch"
            placeholder="Enter Branch"
        /></span>
        <span
        ><input
          type="text"
          formControlName="Remark"
          placeholder="Enter Remark"
      /></span>

            <span
              ><button
                class="delete_icon trash"
                (click)="deleteBankDetail(i, bankDetail.value)"
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>
        </div>

        <div class="submit">
          <button class="submit_button" (click)="onSubmit(bankForm.value)">
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
